var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackgroundProfileTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1828 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_16784)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_16784)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -26,
    y: -286,
    width: 1880,
    height: 1105
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18px)",
      clipPath: "url(#bgblur_1_47_16784_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 15H1802C1810.28 15 1817 21.7157 1817 30V157H11V30C11 21.7157 17.7157 15 26 15Z",
    stroke: "#A8F0E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_47_16784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818 -250H10V783H1818V-250Z",
    fill: "url(#paint0_linear_47_16784)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1656 401V-51H1272V401H1656Z",
    fill: "url(#paint1_linear_47_16784)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1656 -51V401H1736L1732.03 78.7339L1656 -51Z",
    fill: "url(#paint2_linear_47_16784)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1442 401V56H1057V401H1442Z",
    fill: "url(#paint3_linear_47_16784)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1442 56V401H1521L1517.09 155.019L1442 56Z",
    fill: "url(#paint4_linear_47_16784)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_16784",
    x: -4,
    y: 0,
    width: 1840,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_16784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_16784",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_47_16784_clip_path",
    transform: "translate(26 286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 15H1802C1810.28 15 1817 21.7157 1817 30V157H11V30C11 21.7157 17.7157 15 26 15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_16784",
    x1: 1970,
    y1: 583,
    x2: 9.9253,
    y2: -249.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#526E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_16784",
    x1: 1433.06,
    y1: 200.694,
    x2: 1879.13,
    y2: -172.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#526E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_16784",
    x1: 1632.2,
    y1: 191.889,
    x2: 1838.56,
    y2: 136.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47_16784",
    x1: 1112.51,
    y1: 307.595,
    x2: 1669.8,
    y2: -14.2415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#526E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47_16784",
    x1: 1430.13,
    y1: 239.124,
    x2: 1634.18,
    y2: 198.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526E98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_16784"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 30C10 21.1634 17.1634 14 26 14H1802C1810.84 14 1818 21.1634 1818 30V158H10V30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_47_16784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1808,
    height: 1033,
    fill: "white",
    transform: "translate(10 -250)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackgroundProfileTwo);
export default __webpack_public_path__ + "static/media/ic-background-profile-two.7420e9947ff63a9f786ddcce4cd2aa4b.svg";
export { ForwardRef as ReactComponent };